module.exports = __webpack_public_path__ + "static/media/105-shopping cart.213f47eb.svg";